import { PageComponentsFormValidationSchema } from '../../../../pageComponents.interface';


export const pageComponentsFormValidationSchema: PageComponentsFormValidationSchema = {
  name: [
    { required: true, message: 'Введіть назву компонента' },
    { type: 'string', message: 'Назва має бути строкою' },
    { min: 3, max: 100, message: 'Назва має бути довжиною не менше 3 символів та не більше 100' }
  ],
  content: [
    { required: true, message: 'Задайте вміст компонента' },
    { type: 'string', message: 'Вміст має бути строкою' },
    {
      min: 3,
      max: Number.MAX_SAFE_INTEGER,
      message: `Вміст має бути довжиною не менше 3 символів та не більше ${ Number.MAX_SAFE_INTEGER }`
    }
  ]
};
